import { render } from "./CDBWorkspace.vue?vue&type=template&id=0bff529a&scoped=true"
import script from "./CDBWorkspace.vue?vue&type=script&lang=js"
export * from "./CDBWorkspace.vue?vue&type=script&lang=js"

import "./CDBWorkspace.vue?vue&type=style&index=0&id=0bff529a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bff529a"]])

export default __exports__